import React, { useMemo } from "react";
import { Card, Table, Tag, Button, TableColumnsType } from "antd";
import { CheckSquareOutlined } from "@ant-design/icons";
import { useGetCommunications } from "~/services/communication";
import { TClient, TCommunication } from "~/types";
import dayjs from "dayjs";
import { PreferredCommunicationMethod } from "~/utils/constants";
import { renderChannel } from "~/utils/channels";

const CommunicationHistory: React.FC = () => {
  const { data } = useGetCommunications();
  const columns = useMemo<TableColumnsType<TCommunication>>(
    () => [
      {
        title: "Sent Date",
        dataIndex: "createdAt",
        key: "sentDate",
        render: (createdAt) => dayjs(createdAt).format("MMM D, YYYY hh:mm"),
      },
      {
        title: "Template",
        dataIndex: ["template", "name"],
        key: "template",
        render: (name: string | undefined, record: TCommunication) =>
          record.template?.name || record.subject || 'N/A',
      },
      {
        title: "Recipient",
        dataIndex: ["jobTicket", "client"],
        key: "recipient",
        render: (client: TClient | null) =>
          client?.companyName ||
          (client?.firstName && client?.lastName ? `${client.firstName} ${client.lastName}` : 'N/A'),
      },
      {
        title: "Channel",
        dataIndex: "channels",
        key: "channel",
        render: (channel: PreferredCommunicationMethod) => renderChannel[channel],
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status: string) => <Tag color="green">{status}</Tag>,
      },
      {
        title: "Opened",
        dataIndex: "opened",
        key: "opened",
        render: (opened: string | null) =>
          opened ? (
            <span style={{ color: "#52c41a" }}>
              <CheckSquareOutlined style={{ marginRight: 4 }} />
              {opened}
            </span>
          ) : (
            <span style={{ color: "#8c8c8c" }}>Not opened</span>
          ),
      },
    ],
    []
  );
  return (
    <Card
      title="Recent Communication History"
      extra={<Button>View All</Button>}
    >
      <Table columns={columns} dataSource={data?.items} pagination={false} />
    </Card>
  );
};

export default CommunicationHistory;
